<div *ngIf="item?.success; else failedBlock">
  <span class="success"><i class="fas fa-check"></i>{{ 'general.success' | translate }}</span>
</div>

<ng-template #failedBlock>
  <span class="failed"><i class="fas fa-times"></i>{{ 'general.failed' | translate }}</span>
</ng-template>
